/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 21 2023
 **/

import * as APIs from "./private";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useSpace(events: API.Events = {}, options: API.Options = { initialStart: false }) {
	return {
		...APIs.UserAdmin.withSpace(events),
		...APIs.UserAdmin.withSpaceUser(events),
		//*
		...APIs.withSpace(events),
		...APIs.withSpaceInvite(events),
		...APIs.withSpaceKeyword(events),
		...APIs.withSpaceRecommend(events),
		...APIs.withSpaceTheme(events),
		...APIs.withSpaceUser(events),
		...APIs.withSpaceOpenworld(events)
		/*/
		...APIs.withSpaceV2(events),
		...APIs.withSpaceInviteV2(events),
		...APIs.withSpaceKeywordV2(events),
		...APIs.withSpaceRecommendV2(events),
		...APIs.withSpaceThemeV2(events),
		...APIs.withSpaceUserV2(events),
		...APIs.withSpaceOpenworldV2(events)
		//*/
	};
}
